var headerWrap = document.getElementById('main-header'),
   steps = document.querySelectorAll('.step'),
   logoPos = headerWrap.dataset.logoPosition,
   mobilelogoPos = headerWrap.dataset.mobileLogoPosition,
   hasMenu = headerWrap.dataset.hasmenu;

if (0 !== steps.length) {
   const scroller = scrollama();
   scroller
      .setup({
         step: steps,
         offset: .25
      })
      .onStepEnter((r) => {
         var animClassEnter = r.element.dataset.animateEnter;
         headerWrap.setAttribute('class', 'header ' + animClassEnter + ' ' + logoPos + ' ' + mobilelogoPos + ' ' + hasMenu);
      }),
      // .onStepExit((r) => {
      //    console.log(r.element);
      //    // var animClassUp = element.dataset.animateUp;
      //    // headerWrap.setAttribute('class', 'header ' + animClassUp + ' ' + logoPos + ' ' + mobilelogoPos + ' ' + hasMenu);
      // }),
   window.addEventListener("resize", scroller.resize)
}
